import React from 'react';

import BulkSelectToggleButton from 'components/lib/BulkSelectToggleButton';

import { useUserManagementContext } from './UserManagementContext';

const UserManagementBulkSelectButton = () => {
  const { filters, isMultipleSelection, setMultipleSelection, clearSelection } = useUserManagementContext();
  const isDisabled = !filters.companies?.length;

  const handleToggleMultipleSelection = () => {
    if (isMultipleSelection) {
      clearSelection();
      return;
    }

    setMultipleSelection(true);
  };

  return (
    <BulkSelectToggleButton
      active={isMultipleSelection}
      disabled={isDisabled}
      tooltipTitle={isDisabled ? 'Filter by company to enable multi select' : undefined}
      onClick={handleToggleMultipleSelection}
      dataTestId="user-management-bulk-select"
    />
  );
};

export default UserManagementBulkSelectButton;
